import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../BaseUrl/baseurl";
import axios from "axios";
import { usersAPIs } from "../../Components/constants/constants";
const token = localStorage.getItem("token");
const headers = {
    headers: {
        authorization: token
    }
};

export const dummyTickets = [
    {
        ticketId: "T001",
        issuer: "John Doe",
        email: "john.doe@example.com",
        phone: "+1234567890",
        subject: "Login Issues",
        description:
            "I am unable to log in to my account. The login button doesn't seem to respond.",
        date: "2023-12-21T08:30:00Z"
    },
    {
        ticketId: "T002",
        issuer: "Jane Smith",
        email: "jane.smith@example.com",
        phone: "+9876543210",
        subject: "Payment Inquiry",
        description:
            "I have a question regarding my recent payment. Could you provide more details about the charges on my invoice?",
        date: "2023-12-20T15:45:00Z"
    },
    {
        ticketId: "T003",
        issuer: "Bob Johnson",
        email: "bob.johnson@example.com",
        phone: "+1122334455",
        subject: "Technical Glitch",
        description:
            "I encountered an error message when trying to access a specific feature. The error code is ABC123.",
        date: "2023-12-19T10:20:00Z"
    },
    {
        ticketId: "T004",
        issuer: "Alice Davis",
        email: "alice.davis@example.com",
        phone: "+9988776655",
        subject: "Product Feedback",
        description:
            "I have some suggestions for improving the user interface. Where can I submit feedback?",
        date: "2023-12-18T14:10:00Z"
    },
    {
        ticketId: "T005",
        issuer: "Charlie Brown",
        email: "charlie.brown@example.com",
        phone: "+5544332211",
        subject: "Account Security",
        description:
            "I received an email about suspicious activity on my account. Can you help me secure my account?",
        date: "2023-12-17T09:55:00Z"
    }
];

export const getTicketList = createAsyncThunk("getTicketList", async role => {
    let response;
    try {
        response = await axios.get(
            `${baseUrl}/supporttickets/alltickets`,
            headers
        );
    } catch (error) {
        console.log(error);
        return [];
    }

    return response.data.data;
});

export const getTicketbyTicketId = createAsyncThunk(
    "getTicketbyTicketId",
    async ticketId => {
        let response;
        try {
            response = await axios.get(
                `${baseUrl}/supporttickets/getticket/${ticketId}`,
                headers
            );
        } catch (error) {
            console.log("get Ticket by Ticket Id error", error);
            return {};
        }

        return response.data;
    }
);

// Define the initial state for the slice
const initialState = {
    tickets: [],
    ticketDescription: {},
    status: "",
    error: "",
    evaluatorLeadList: [],
    verfiedEvaluators: []
};

const supportSlice = createSlice({
    name: "support",
    initialState,
    reducers: {
        clearKycUserid: state => {
            state.KycUserid = {};
        },
        setVerifiedEvaluators: (state, action) => {
            console.log("iss data therem ver", state.Users);
            state.verfiedEvaluators = action.payload.filter(
                evaluator => evaluator.isVerifiedByAdmin === "Verified"
            );
        }
    },
    extraReducers(builder) {
        // get Users List
        builder
            .addCase(getTicketList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getTicketList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.tickets = action.payload;
            })
            .addCase(getTicketList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })

            //Get user By ID
            .addCase(getTicketbyTicketId.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getTicketbyTicketId.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.ticketDescription = action.payload.ticket;
            })
            .addCase(getTicketbyTicketId.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export const { clearKycUserid, setVerifiedEvaluators } = supportSlice.actions;

export default supportSlice.reducer;
